export const getStorage = (key) => {
  return localStorage.getItem(key);
};
